import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { lensPath, set } from 'ramda';

import GetInTouchForm from './Form';
import Text from '../shared/Text';
import { fillSpace, breakpoints, palette } from '../../constants/styles';
import FinautaWhiteLogo from '../../images/svgs/finauta/logo-white.svg';
import { WhiteLogo } from '../shared/resultsStyles';
import { stringToNumber, getGoalNames, iOSSafari, getMaxQuestions } from '../../constants/utils';
import ProgressBar from '../shared/ProgressBar';

import { HEADER_HEIGHT, FlowHeader } from '../SavingsFlow/styles';
import { PENSION_PLAN_PRICE } from '../../constants/constants';

const SCROLL_OFFSET = 350;

const StyledSavingsFlow = styled.div`
  display: flex;
  flex-direction row;
  ${fillSpace}
`;

const FlowContent = styled.div`
  display: flex;
  align-items: center;
  height: calc(100vh - 50px);
  margin-top: ${HEADER_HEIGHT}px;
  padding: 0 20px;
  background-color: white;

  ${breakpoints.tablet} {
    width: 70%;
    margin-left: 15%;
    margin-right: 15%;
  }

  ${breakpoints.tabletLandscape} {
    width: 60%;
    margin-left: 20%;
    margin-right: 20%;
  }
`;

class SavingsFlow extends Component {
  state = {
    isFinished: false,
    questionnaire: [],
    focusedGoal: 0,
    focusedQuestion: 0,
    questionsAnswered: [],
    totalQuestions: 0,
    globalDitchedQuestions: 0,
    inputList: [],
    howManyDitchedMemory: [],
    savingsForm: [],
    userAge: null,
    valuePropContent: {},
  };

  componentDidMount = () => {
    const { tool } = this.props;
    let valueProp = {};
    switch (tool) {
      case 'plan':
        valueProp = {
          title: 'Platiquemos',
          subtitle: (
            <Fragment>
              Déjanos tu información de contacto para platicar con uno de nuestros expertos,{' '}
              <span style={{ fontWeight: 500, color: palette.secondaryColor }}>es gratis</span>
            </Fragment>
          ),
          bullets: [
            'Pregunta sobre tus finanzas sin compromiso',
            'Personaliza tu plan con un experto certificado',
            'Comienza tu plan cuando tú quieras',
          ],
          question: {
            title: '¿Cómo gana Finauta?',
            answer: (
              <div style={{ marginTop: '0.5rem' }}>
                <Text
                  type="body1"
                  align="left"
                  styles={css`
                    margin-top: 0.5rem;
                  `}
                >
                  En caso de querer comenzar tu plan, la institución financiera que tú elijas para
                  llevarlo a cabo tu plan nos paga una comisión por haberte ayudado a encontrarla.
                </Text>
                <Text
                  type="body1"
                  align="left"
                  styles={css`
                    margin-top: 0.5rem;
                  `}
                >
                  <span style={{ fontWeight: 500, textDecoration: 'underline' }}>
                    Finauta no maneja tu dinero
                  </span>
                  , sólo te hacemos recomendaciones y te ayudamos a implementar tu plan.
                </Text>
              </div>
            ),
          },
        };
        break;
      case 'retiro':
        valueProp = {
          title: 'Platiquemos',
          subtitle: (
            <Fragment>
              Déjanos tu información de contacto para platicar con uno de nuestros expertos,{' '}
              <span style={{ fontWeight: 500, color: palette.secondaryColor }}>es gratis</span>
            </Fragment>
          ),
          bullets: [
            'Pregunta sobre tus finanzas sin compromiso',
            'Descubre cuánto ahorrar para lograr tu retiro ideal',
            'Comienza a ahorrar, nosotros te recomendamos dónde',
          ],
          question: {
            title: '¿Cómo gana Finauta?',
            answer: (
              <div style={{ marginTop: '0.5rem' }}>
                <Text
                  type="body1"
                  align="left"
                  styles={css`
                    margin-top: 0.5rem;
                  `}
                >
                  En caso de querer ahorrar para tu retiro, la institución financiera que tú elijas
                  para hacerlo nos paga una comisión por haberte ayudado a encontrarla.
                </Text>
                <Text
                  type="body1"
                  align="left"
                  styles={css`
                    margin-top: 0.5rem;
                  `}
                >
                  <span style={{ fontWeight: 500, textDecoration: 'underline' }}>
                    Finauta no maneja tu dinero
                  </span>
                  , sólo te hacemos recomendaciones y te ayudamos a ahorrar para el retiro.
                </Text>
              </div>
            ),
          },
        };
        break;
      case 'pension':
        valueProp = {
          title: 'Platiquemos',
          subtitle: (
            <Fragment>
              Déjanos tu información de contacto para platicar con uno de nuestros expertos,{' '}
              <span style={{ fontWeight: 500, color: palette.secondaryColor }}>es gratis</span>
            </Fragment>
          ),
          bullets: [
            'Pregunta sobre tus finanzas sin compromiso',
            'Descubre cómo sacarle el mayor provecho a tu pensión',
            'Logra un retiro digno, nosotros te acompañamos',
          ],
          question: {
            title: '¿Cómo gana Finauta?',
            answer: (
              <div style={{ marginTop: '0.5rem' }}>
                <Text
                  type="body1"
                  align="left"
                  styles={css`
                    margin-top: 0.5rem;
                  `}
                >
                  En caso de querer ahorrar para tu retiro, la institución financiera que tú elijas
                  para hacerlo nos paga una comisión por haberte ayudado a encontrarla.
                </Text>
                <Text
                  type="body1"
                  align="left"
                  styles={css`
                    margin-top: 0.5rem;
                  `}
                >
                  <span style={{ fontWeight: 500, textDecoration: 'underline' }}>
                    Finauta no maneja tu dinero
                  </span>
                  , sólo te hacemos recomendaciones y te ayudamos a ahorrar para el retiro.
                </Text>
              </div>
            ),
          },
        };
        break;
      case 'pensionMod40':
        valueProp = {
          title: 'Solicitud de plan de pensión',
          subtitle: (
            <Fragment>
              <Text type="body1">
                Déjanos tus datos para que uno de nuestros expertos en pensiones se ponga en
                contacto contigo a la brevedad.
              </Text>
              <Text type="body1" styles={{ marginTop: '20px' }}>
                <b>La llamada es gratis</b> y el plan tiene un costo de ${PENSION_PLAN_PRICE}.
                Recibirás tu plan tras realizar el pago.
              </Text>
            </Fragment>
          ),
          bullets: [],
        };
        break;
      case 'wa':
        valueProp = {
          title: 'Platiquemos',
          subtitle: (
            <Fragment>
              Déjanos tu información de contacto para platicar con uno de nuestros expertos,{' '}
              <span style={{ fontWeight: 500, color: palette.secondaryColor }}>es gratis</span>
            </Fragment>
          ),
          bullets: [
            'Pregunta sobre tus finanzas sin compromiso',
            'Descubre cuánto ahorrar para lograr tus metas',
            'Logra un retiro digno, nosotros te acompañamos',
          ],
          question: {
            title: '¿Cómo gana Finauta?',
            answer: (
              <div style={{ marginTop: '0.5rem' }}>
                <Text
                  type="body1"
                  align="left"
                  styles={css`
                    margin-top: 0.5rem;
                  `}
                >
                  En caso de querer ahorrar para tu retiro, la institución financiera que tú elijas
                  para hacerlo nos paga una comisión por haberte ayudado a encontrarla.
                </Text>
                <Text
                  type="body1"
                  align="left"
                  styles={css`
                    margin-top: 0.5rem;
                  `}
                >
                  <span style={{ fontWeight: 500, textDecoration: 'underline' }}>
                    Finauta no maneja tu dinero
                  </span>
                  , sólo te hacemos recomendaciones y te ayudamos a ahorrar para el retiro.
                </Text>
              </div>
            ),
          },
        };
        break;
      case 'wa':
        valueProp = {
          title: 'Platiquemos',
          subtitle: (
            <Fragment>
              Déjanos tu información de contacto para platicar con uno de nuestros expertos,{' '}
              <span style={{ fontWeight: 500, color: palette.secondaryColor }}>es gratis</span>
            </Fragment>
          ),
          bullets: [
            'Pregunta sobre tus finanzas sin compromiso',
            'Descubre cuánto ahorrar para lograr tus metas',
            'Logra un retiro digno, nosotros te acompañamos',
          ],
          question: {
            title: '¿Cómo gana Finauta?',
            answer: (
              <div style={{ marginTop: '0.5rem' }}>
                <Text
                  type="body1"
                  align="left"
                  styles={css`
                    margin-top: 0.5rem;
                  `}
                >
                  En caso de querer ahorrar para tu retiro, la institución financiera que tú elijas
                  para hacerlo nos paga una comisión por haberte ayudado a encontrarla.
                </Text>
                <Text
                  type="body1"
                  align="left"
                  styles={css`
                    margin-top: 0.5rem;
                  `}
                >
                  <span style={{ fontWeight: 500, textDecoration: 'underline' }}>
                    Finauta no maneja tu dinero
                  </span>
                  , sólo te hacemos recomendaciones y te ayudamos a ahorrar para el retiro.
                </Text>
              </div>
            ),
          },
        };
        break;
      case 'deuda':
        valueProp = {
          title: 'Platiquemos',
          subtitle: (
            <Fragment>
              Déjanos tu información de contacto para platicar con uno de nuestros expertos,{' '}
              <span style={{ fontWeight: 500, color: palette.secondaryColor }}>es gratis</span>
            </Fragment>
          ),
          bullets: [
            'Pregunta sobre tus finanzas sin compromiso',
            'Obtén opciones para cambiar tu deuda',
            'Cambia tu deuda, nosotros te ayudamos',
          ],
          question: {
            title: '¿Cómo gana Finauta?',
            answer: (
              <div style={{ marginTop: '0.5rem' }}>
                <Text
                  type="body1"
                  align="left"
                  styles={css`
                    margin-top: 0.5rem;
                  `}
                >
                  En caso de querer cambiar tu deuda, la institución financiera que tú elijas para
                  hacerlo nos paga una comisión por haberte ayudado a encontrarla.
                </Text>
                <Text
                  type="body1"
                  align="left"
                  styles={css`
                    margin-top: 0.5rem;
                  `}
                >
                  <span style={{ fontWeight: 500, textDecoration: 'underline' }}>
                    Finauta no te da un crédito
                  </span>
                  , nosotros sólo te mostramos opciones y te ayudamos para que tú elijas la que más
                  te convenga.
                </Text>
              </div>
            ),
          },
        };
        break;
      default:
        break;
    }
    this.setState({ valuePropContent: valueProp });
    this.initializeForm(this.props);
    this.setQuestionAsFocused();
    document.addEventListener('keyup', this.keyPress, false);
  };

  componentWillUnmount() {
    document.removeEventListener('keyup', this.keyPress, false);
  }

  setGoalAsFocused = (goalIndex = 0) => {
    this.setState((state) => ({
      ...set(lensPath(['questionnaire', goalIndex, 'isFocused']), true, state),
      focusedGoal: goalIndex,
    }));
  };

  setGoalAsAnswered = (goalIndex = 0) => {
    this.setState((state) => ({
      ...set(lensPath(['questionnaire', goalIndex, 'isAnswered']), true, state),
    }));
  };

  setQuestionAsFocused = (goalIndex = 0, questionIndex = 0) => {
    this.setGoalAsFocused(goalIndex);
    this.setState((state) => ({
      ...set(
        lensPath(['questionnaire', goalIndex, 'questions', questionIndex, 'isFocused']),
        true,
        state,
      ),
      focusedGoal: goalIndex,
      focusedQuestion: questionIndex,
    }));
  };

  setAllAsBlur = (cb) => {
    const { questionnaire } = this.state;
    this.setState(
      {
        ...this.state,
        questionnaire: questionnaire.map((goal) => ({
          ...goal,
          isFocused: false,
          questions: goal.questions.map((question) => ({
            ...question,
            isFocused: false,
          })),
        })),
      },
      cb,
    );
  };

  setGoalAnswers = (values, goalName, goalIndex) => {
    this.setState((state) => ({
      ...set(lensPath(['savingsForm', goalIndex]), values, state),
    }));
  };

  initializeForm = ({ questionIndex = 0, questionnaire, ditchedQuestions = 0 }, cb) => {
    const { globalDitchedQuestions, howManyDitchedMemory } = this.state;
    this.setState(
      {
        questionnaire,
        totalQuestions: getMaxQuestions(questionnaire) - globalDitchedQuestions - ditchedQuestions,
        globalDitchedQuestions: globalDitchedQuestions + ditchedQuestions,
        howManyDitchedMemory: [...howManyDitchedMemory, [questionIndex, ditchedQuestions]],
        goalNames: getGoalNames(questionnaire),
      },
      () => {
        this.updateInputList(cb);
      },
    );
  };

  updateInputList = (cb) => {
    const inputsFound = document.querySelectorAll('.question');
    const inputList = [];
    inputsFound.forEach((input) => {
      inputList.push(input.id);
    });
    this.setState({ inputList }, cb);
  };

  injectNewQuestions = (newQuestions = [], goalIndex, questionIndex, ditchedQuestions, cb) => {
    const { questionnaire } = this.state;
    const newQuestionnaire = [...questionnaire];
    newQuestionnaire[goalIndex].questions.splice(questionIndex + 1, 0, ...[...newQuestions]);
    newQuestionnaire[goalIndex].questions[questionIndex].lastSaved = ditchedQuestions;
    this.initializeForm({ questionIndex, questionnaire: newQuestionnaire, ditchedQuestions }, cb);
  };

  removeNewQuestions = (goalIndex, questionIndex, ditchedQuestions, cb) => {
    const { questionnaire, howManyDitchedMemory, questionsAnswered } = this.state;
    const newQuestionnaire = [...questionnaire];

    let updateGlobalDitched = 0;
    let howManySteps = 0;
    for (let i = 0; i < howManyDitchedMemory.length; i += 1) {
      if (howManyDitchedMemory[i][0] < questionIndex) {
        updateGlobalDitched += howManyDitchedMemory[i][1];
      } else {
        howManySteps = i;
        break;
      }
    }

    // console.log(updateGlobalDitched);
    // console.log(howManySteps);

    // Remove all the extra memory and set the globalDitched again
    this.setState({
      howManyDitchedMemory: howManyDitchedMemory.splice(howManySteps),
      globalDitchedQuestions: updateGlobalDitched,
    });

    // console.log(questionIndex);
    // console.log("past",this.state.globalDitchedQuestions);
    // console.log("future",updateGlobalDitched);
    // console.log(newQuestionnaire);
    // console.log(newQuestionnaire[goalIndex]);

    if (newQuestionnaire[goalIndex]) {
      for (let i = questionIndex + 1; i < newQuestionnaire[goalIndex].questions.length; ) {
        if (!newQuestionnaire[goalIndex].questions[i].base) {
          newQuestionnaire[goalIndex].questions.splice(i, 1);
        } else {
          break;
        }
      }
    }

    // Esta es una súper mexicanada: Lo que necesitaba resolver era lo siguiente... Cada vez que quitabamos
    // preguntas del formulario, la cantidad total de preguntas se actualizaba correctamente, sin embargo
    // la cantidad de preguntas ya contestadas se mantenía, lo que hacía que potencialmente el usuario acabara sin
    // realmente haber acabado. Entonces intenté de muchísimas maneras cambiar el valor de preguntas ya contestadas,
    // pero por alguna extraña razón el valor seguía regresando a la cantidad de respuestas que existen en el JSON.
    // La solución fue que en vez de disminuir la cantidad de preguntas contestadas, lo que hice fue incrementar la
    // cantidad de preguntas restantes. Esto no reflejará la realidad pero proveera una buena experiencia de usuario.
    if (questionsAnswered[0]) {
      this.initializeForm(
        {
          questionnaire: newQuestionnaire,
          ditchedQuestions: -newQuestionnaire[goalIndex].questions[questionIndex].lastSaved,
        },
        cb,
      );
    } else {
      this.initializeForm(
        {
          questionnaire: newQuestionnaire,
          ditchedQuestions,
        },
        cb,
      );
    }
  };

  handleQuestionFocus = (ev, index, goalId) => {
    const { questionnaire } = this.state;
    const element = ev.target;
    const currentGoalIndex = questionnaire.findIndex((goal) => goal.value === goalId);
    this.setAllAsBlur(() => {
      this.setQuestionAsFocused(currentGoalIndex, index);
      /** We need to do it with this method (getBoundingClientRect) so we can preserve the
       * right offset even with relative positioned elements.
       */
      const offsetTop = element.getBoundingClientRect().top + window.scrollY;
      if (!iOSSafari) {
        window.scrollTo({ top: offsetTop - SCROLL_OFFSET });
      }
    });
  };

  handleQuestionChange = (ev) => {
    this.setState({ isFinished: false });
    const inputId = ev.target.id;
    const inputName = ev.target.name;
    const inputValue = ev.target.value === '' ? null : Number(ev.target.value);

    if (inputName === 'age') {
      this.setState({ userAge: inputValue });
    }
    this.setState({ currentInputId: inputId });
  };

  handleQuestionBlur = (ev, { values = [], goalAnswered, goalIndex, goalName }) => {
    const arrValues = Object.keys(values).map((key) => values[key]);
    this.setState((state) => ({
      ...set(lensPath(['questionsAnswered', goalIndex]), arrValues.length, state),
    }));
    this.setGoalAnswers(values, goalName, goalIndex);

    if (goalAnswered) {
      this.setGoalAsAnswered(goalIndex);
    }
  };

  handleFormAnswered = (data, cb) => {
    const { values = [], goalAnswered, goalIndex, goalName } = data;
    console.log(values);
    const arrValues = Object.keys(values).map((key) => values[key]);
    this.setState((state) => ({
      ...set(lensPath(['questionsAnswered', goalIndex]), arrValues.length, state),
    }));
    this.setGoalAnswers(values, goalName, goalIndex);

    if (goalAnswered) {
      this.setGoalAsAnswered(goalIndex);
    }
    cb();
  };

  handleStepSubmit = (questionId = '') => {
    const { savingsForm } = this.state;
    const { onStepSubmit } = this.props;
    onStepSubmit(savingsForm);
  };

  goToNextInput = (questionId) => {
    const { inputList } = this.state;
    const currentInputIndex = inputList.findIndex((id) => id === questionId);
    const nextInputName = inputList[currentInputIndex + 1];
    const nextInput = document.querySelector(`#${nextInputName}`);
    if (nextInput) {
      nextInput.focus();
      if (!iOSSafari) {
        window.scrollTo({ top: nextInput.offsetTop - SCROLL_OFFSET });
      }
    } else {
      this.setState({ isFinished: true });
      this.handleStepSubmit(questionId);
    }
  };

  keyPress = (ev) => {
    const { currentInputId } = this.state;
    if (ev.keyCode === 13 || ev.keyCode === 9) {
      ev.preventDefault();
      this.goToNextInput(currentInputId);
    }
  };

  render() {
    const {
      questionnaire,
      isFinished,
      userAge,
      questionsAnswered,
      totalQuestions,
      valuePropContent,
    } = this.state;
    const totalAnswers = questionsAnswered.reduce((acc, cur) => acc + cur, 0);
    return (
      <StyledSavingsFlow>
        <FlowHeader>
          <ProgressBar current={totalAnswers + 0.5} total={totalQuestions - 0.5} />
          <WhiteLogo src={FinautaWhiteLogo} id="logo" />
        </FlowHeader>
        <FlowContent>
          <GetInTouchForm
            questionnaire={questionnaire}
            onQuestionFocus={this.handleQuestionFocus}
            onQuestionChange={this.handleQuestionChange}
            onQuestionBlur={this.handleQuestionBlur}
            onStepSubmit={this.handleStepSubmit}
            goToNextInput={this.goToNextInput}
            isFinished={isFinished}
            userAge={userAge}
            valuePropContent={valuePropContent}
            getSubmitRef={(ref) => {
              this.submitContainer = ref;
            }}
            injectNewQuestions={this.injectNewQuestions}
            removeNewQuestions={this.removeNewQuestions}
            handleFormAnswered={this.handleFormAnswered}
          />
        </FlowContent>
      </StyledSavingsFlow>
    );
  }
}

SavingsFlow.propTypes = {
  onStepSubmit: PropTypes.func,
};

SavingsFlow.defaultProps = {
  onStepSubmit: () => {},
};

export default SavingsFlow;
